const rootRelativePrefixes = ['image-cache/', 'image/cache/'];

export function toRootRelativeImagePath(path?: string) {
    if (!path) {
        return path;
    }

    if (!rootRelativePrefixes.some(prefix => path.startsWith(prefix))) {
        return path;
    }

    const imageRootPath = (
        process.env.REACT_APP_IMAGE_ROOT_URL
        ?? process.env.IMAGE_ROOT_URL
        ?? process.env.REACT_APP_IMAGE_ROOT_PATH
        ?? process.env.IMAGE_ROOT_PATH
    )?.trim().replace(/\/+$/, '');

    if (!imageRootPath) {
        return `/${path}`;
    }

    return `${imageRootPath}/${path.replace(/^\/+/, '')}`;
}
